
    var riot = require('riot')
    //src: starling/src/tags/link.html
riot.tag2('link',
  '<svg ref="svg" class=" link-container link-{id} {hidden: !showArc()} {collapsed-link: showCollapsedArc()} size-{opts.instance.lineWidth} link-{color} {show-from-arrow: showFromArrow} {show-to-arrow: showToArrow} {show-from-dot: showFromDot} {show-to-dot: showToDot} {top-level-link: opts.instance.isTopLevel()} "> <defs> <clippath ref="clipPath" id="box-clip-{id}"> <path ref="clipPathPath" clip-rule="evenodd" class="clipper" d="M -10000,-10000 10000,-10000 10000,10000 -10000,10000 -10000,-10000"></path> </clipPath> <marker id="diamond-selected" markerwidth="40" markerheight="40" refx="5" refy="5" orient="auto" markerunits="userSpaceOnUse" viewbox="-2 -2 20 20"> <path d="M 5,1 L 9,5 5,9 1,5 z" class="link-diamond"></path> </marker> <marker id="diamond-selected-hovered" markerwidth="40" markerheight="40" refx="5" refy="5" orient="auto" markerunits="userSpaceOnUse" viewbox="-2 -2 20 20"> <path d="M 5,1 L 9,5 5,9 1,5 z" class="link-diamond-halo"></path> <path d="M 5,1 L 9,5 5,9 1,5 z" class="link-diamond"></path> </marker> </defs> <text class="from backing {showFromArrow ? \'arrow\' : \'dot\'}"> <textpath xlink:href="#text-path-{id}-backing"> <tspan if="{!isSelected()}" ref="fromDotBacking" class="from-dot-backing" data-shifted-hidden data-x="0" y="0">&#xf111;</tspan> <tspan ref="fromArrowBacking" class="from-arrow-backing" data-shifted-x="14" data-x="0" y="0">&#xe900;</tspan> </textPath> </text> <text class="to backing {showToArrow ? \'arrow\' : \'dot\'}" text-anchor="end"> <textpath xlink:href="#text-path-{id}-backing" startoffset="100%"> <tspan if="{!isSelected()}" ref="toDotBacking" class="to-dot-backing" data-shifted-hidden data-x="0" y="0">&#xf111;</tspan> <tspan ref="toArrowBacking" class="to-arrow-backing" data-shifted-x="-14" data-x="0" y="0">&#xe901;</tspan> </textPath> </text> <path ref="container" id="text-path-{id}-backing" class="link-backing {expanded: canvas.getSelectedElementIds().includes(id)}" riot-d="{path}" clip-path="url(#box-clip-{id})" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}"></path> <text class="from-marker"> <textpath ref="fromMarker" xlink:href="#text-path-{id}"> <tspan if="{!isSelected()}" ref="fromDot" class="from-dot" data-shifted-hidden data-x="0" y="0">&#xf111;</tspan> <tspan ref="fromArrow" class="from-arrow" data-x="0" data-shifted-x="14" y="0">&#xe900;</tspan> </textPath> </text> <text class="to-marker" text-anchor="end"> <textpath xlink:href="#text-path-{id}" startoffset="100%"> <tspan if="{!isSelected()}" ref="toDot" class="to-dot" data-shifted-hidden data-x="0" y="0">&#xf111;</tspan> <tspan ref="toArrow" class="to-arrow" data-shifted-x="-14" data-x="0" y="0">&#xe901;</tspan> </textPath> </text> <path ref="path" id="text-path-{id}" class="link" riot-d="{path}" clip-path="url(#box-clip-{id})" stroke-dasharray="{getDashArray(opts.instance.lineType, opts.instance.lineWidth)}" marker-end="{getMarker()}" marker-start="{getMarker()}"></path> </svg>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _geom = require('lib/geom');

var _util = require('lib/util');

var _constants = require('lib/constants');

var _perspectivesUi = require('lib/perspectives-ui');

var _zoomUi = require('lib/zoom-ui');

var _appUi = require('lib/app-ui');

var _relationshipUi = require('lib/relationship-ui');

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _linksUi = require('lib/links-ui');

var _creationToolsUi = require('lib/creation-tools-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = this;

this.instance = opts.instance;
this.id = opts.instance.id;
this.color = opts.instance.color;
this.lineType = opts.instance.lineType;
this.showArc = opts.instance.showArc;

this.lineWidth = _constants.LINK_WIDTHS_MAPPING[opts.instance.lineWidth] || _constants.LINK_WIDTHS_MAPPING[_constants.DEFAULTS.LINK_WIDTH];

this.direction = opts.instance.direction;

this.canvas = this.parent.canvas;
this.fromNodeId = opts.fromNodeId;
this.toNodeId = opts.toNodeId;

this.hide = function () {
  if (!(_this.refs && _this.refs.svg)) return;
  _this.refs.svg.style.display = 'none';
};

this.unHide = function () {
  if (!(_this.refs && _this.refs.svg)) return;
  _this.refs.svg.style.display = 'inline';
};

this.freshen = function () {
  var describedArc = _this.describeArc();
  _this.updateDescribedArcFields(describedArc);
  if (describedArc.outerBox) {
    _this.setClipPolygon(describedArc.outerBox);
  }
  _this.freshenArrowProps();
};

this.freshenArrowProps = function () {
  var link = _store_instance2.default.getLink(_this.id);

  _this.showFromArrow = _this.direction === 'left' || _this.direction === 'both';
  _this.showToArrow = _this.direction === 'right' || _this.direction === 'both';

  _this.showFromDot = !_this.showFromArrow;
  _this.showToDot = !_this.showToArrow;

  // rendering the dots on drag causes lag.
  if (_this.canvas.dragging) {
    _this.showFromDot = false;
    _this.showToDot = false;
  }
};

this.isInActivePerspective = function () {
  var perspectives = _perspectivesUi.pui.getActivePerspectives();
  if (perspectives.some(function (p) {
    return p.hasMemberLink(_this.id);
  })) {
    return true;
  }
  return false;
};

this.handleMouseEnter = function () {
  _this.unsetMouseLeaveTimeout();
  if (!_this.canvas.dragging) {
    _this.setHoveredState();
  }
};

this.handleMouseLeave = function () {
  _this.hovered = false;
  _this.clearHoverState();
};

this.triggerDelayedMouseLeave = function () {
  /* on a timeout to prevent flickering when you move over a link handle */
  _this.unsetMouseLeaveTimeout();
  _this.mouseLeaveTimeout = setTimeout(function () {
    _this.clearHoverState();

    if (!_this.canvas.isSelectedElement(_this.id)) {
      _this.clearExpandedState();
    }
    _this.hovered = false;
    _this.updateMarkerEnds();
  }, 150);
};

this.isSelected = function () {
  return _this.canvas.isSelectedElement(_this.id);
};

this.unsetMouseLeaveTimeout = function () {
  if (_this.mouseLeaveTimeout) {
    clearTimeout(_this.mouseLeaveTimeout);
    _this.mouseLeaveTimeout = null;
  }
};

this.setHoveredState = function () {
  var _refs = _this.refs,
      svg = _refs.svg,
      container = _refs.container;

  container && container.classList.add('hover');
  svg && svg.classList.add('hover');
  _this.hovered = true;
  _this.updateMarkerEnds();
  _this.refs && _this.refs.container && _this.refs.container.classList.add('hover');
  _this.removeClipPolygon();
};

this.clearHoverState = function () {
  var _refs2 = _this.refs,
      svg = _refs2.svg,
      container = _refs2.container;

  _this.hovered = false;
  container && container.classList.remove('hover');
  svg && svg.classList.remove('hover', 'emphasized');
};

this.clearExpandedState = function () {
  var container = _this.refs.container;

  container && container.classList.remove('expanded');
  //this.refs && this.refs.container && this.refs.container.classList.remove('expanded','hover');
  _this.setClipPolygon();
};

this.on('update', function () {
  _this.freshen();
  if (_this.isSelected()) {
    _this.shiftEnds();
  } else {
    _this.resetEnds();
  }
});

this.on('updated', function (params) {
  if (!params || !params.ignorePlaceLinkNode) {
    if (_this.linkNodeId && _this.canvas.nodeTags[_this.linkNodeId]) {
      _this.instance.placeLinkNode();
      if (_this.canvas.nodeTags[_this.linkNodeId]) {
        _this.canvas.nodeTags[_this.linkNodeId].updatePosition();
      }
    }
  }
});

this.createRCard = function (event) {
  var canvas = _this.canvas,
      id = _this.id;

  var link = _store_instance2.default.getLink(id);
  var linkNodeId = link.linkNodeId;

  if (linkNodeId) {
    var nodeTag = canvas.nodeTags[linkNodeId];
    canvas.toggleSelectedElement(nodeTag);

    if (nodeTag.instance.title === '') {
      nodeTag.focusTitle(true);
    }
  } else {
    canvas.createNodeOnDblClick(event, link);
  }

  canvas.hidePopups();
};

this.on('mount', function () {
  _this.instance = opts.instance.__.item;

  if (_this.linkNodeId && _this.canvas.nodeTags[_this.linkNodeId]) {
    _this.instance.placeLinkNode();
  }
  var describedArc = _this.describeArc();
  _this.updateDescribedArcFields(describedArc);
  var backing = _this.refs.container;
  var toMarker = _this.refs.toMarker;
  var fromMarker = _this.refs.fromMarker;

  _this.setClipPolygon(describedArc.outerBox);

  _this.canvas.linkTags[_this.id] = _this;

  backing.addEventListener('contextmenu', function (e) {
    if (_this.canvas.isViewOnly()) return;
    e.stopPropagation();
    if (e.altKey) return;
    e.preventDefault();

    _this.canvas.linkMenuTag.summon({
      x: e.clientX,
      y: e.clientY,
      link: _this.instance,
      tag: _this
    });

    _appUi.appUI.zoomToLinkIfZoomedOut(_this);
  });

  if (_this.isInActivePerspective()) {
    _this.perspectiveHighlight();
  }

  // click/doubleclick
  var prevAngleStartToR = void 0;
  var prevAngleEndToR = void 0;
  var timer = 0;
  var preventClickAction = void 0;

  var CLICK_DELAY = 200;

  (0, _interactjs2.default)(backing).on('tap', function (event) {
    var canvas = _this.canvas;
    var button = event.button,
        ctrlKey = event.ctrlKey,
        shiftKey = event.shiftKey;

    if (canvas.isViewOnly()) return;
    if (button !== 0) return;
    if (ctrlKey) return;

    timer = setTimeout(function () {
      if (canvas.rightClickMenuIsOpen()) {
        canvas.hideRightClickMenu();
        return;
      }

      if (!preventClickAction) {
        if (document.body.classList.contains('link-dragging')) return;

        if (canvas.activeToolName === 'text') {
          _this.createRCard(event);
          _creationToolsUi.ctui.setActiveTool('pointer');
        } else {
          var _canvas$getMatrix = canvas.getMatrix(),
              scale = _canvas$getMatrix.scale,
              tx = _canvas$getMatrix.tx,
              ty = _canvas$getMatrix.ty;

          canvas.toggleSelectedElement(_this, shiftKey);

          if (shiftKey) {
            canvas.linkMenuTag.hide();
          } else {
            _appUi.appUI.zoomToLinkIfZoomedOut(_this);
          }
        }
      }

      preventClickAction = false;
    }, CLICK_DELAY);
  });

  backing.addEventListener('dblclick', function (e) {
    e.stopPropagation();
    e.preventDefault();
    clearTimeout(timer);
    preventClickAction = true;
    _this.createRCard(e);
    _this.canvas.hidePopups();
  });

  (0, _interactjs2.default)(backing).draggable({
    onstart: function onstart(e) {
      if (_this.canvas.isViewOnly()) {
        return;
      }
      _this.canvas.disablePanZoom();
      document.body.classList.add('link-dragging');
      e.stopImmediatePropagation();
      e.preventDefault();
      e.stopPropagation();
      var link = _store_instance2.default.getLink(self.id);
      prevAngleStartToR = link.angleStartToR;
      prevAngleEndToR = link.angleEndToR;
      _this.updateMarkerEnds();
    },
    onmove: function onmove(e) {
      if (_this.canvas.isViewOnly()) {
        return;
      }
      e.stopImmediatePropagation();
      e.preventDefault();
      e.stopPropagation();

      var link = _store_instance2.default.getLink(self.id);

      var _self$canvas$getMatri = self.canvas.getMatrix(),
          scale = _self$canvas$getMatri.scale,
          tx = _self$canvas$getMatri.tx,
          ty = _self$canvas$getMatri.ty;

      var prevEndPointHits = Object.assign({}, _this.endPointHits);

      _this.endPointHits = {};

      if (_this.isSelected() && link.fromNodeId == 0 && link.toNodeId == 0) {
        link.toEndPoint.x += e.dx / scale;
        link.toEndPoint.y += e.dy / scale;
        link.fromEndPoint.x += e.dx / scale;
        link.fromEndPoint.y += e.dy / scale;
        _this.updatePosition();
        _this.endPointHits = dragdrop.getEndPointHoveredNode(link);
      }

      var endPointHits = _this.endPointHits || {};

      if (endPointHits.to && prevEndPointHits.to && endPointHits.to.node.id != prevEndPointHits.to.node.id) {
        _this.canvas.nodeTags[prevEndPointHits.to.node.id].toggleLineHover(false);
      }
      if (endPointHits.from && prevEndPointHits.from && endPointHits.from.node.id != prevEndPointHits.from.node.id) {
        _this.canvas.nodeTags[prevEndPointHits.from.node.id].toggleLineHover(false);
      }

      if (endPointHits.to) {
        _this.canvas.nodeTags[endPointHits.to.node.id].toggleLineHover(true);
      }

      if (endPointHits.from) {
        _this.canvas.nodeTags[endPointHits.from.node.id].toggleLineHover(true);
      }

      var _ref = _linksUi.linksUI.skewDeltas[_this.id] || { dx: 0, dy: 0 },
          dx = _ref.dx,
          dy = _ref.dy;

      var lNodePoint = {
        x: (e.clientX - tx) / scale - dx,
        y: (e.clientY - ty) / scale - dy
      };
      var fromNodePoint = link.getFromEndPoint();
      var toNodePoint = link.getToEndPoint();

      var margin = _constants.DOG_LEG_AVOID_CARD_MARGIN;
      if (!(0, _geom.rectIsFullyWithinRect)((0, _geom.point2Rect)(lNodePoint), (0, _geom.expandRect)({ rect: fromNodePoint, margin: margin })) && !(0, _geom.rectIsFullyWithinRect)((0, _geom.point2Rect)(lNodePoint), (0, _geom.expandRect)({ rect: toNodePoint, margin: margin }))) {
        link.setAngles({ lNodePoint: lNodePoint });
      }
      _this.canvas.linksTag.update();
      link.placeLinkNode();
      if (self.linkNodeId) {
        _this.canvas.nodeTags[_this.linkNodeId].placeLinkNodesRecursively(self.linkNode());
        _this.canvas.nodeTags[_this.linkNodeId].update();
      }
    },
    onend: function onend(e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();
      if (_this.canvas.isViewOnly()) {
        return;
      }
      document.body.classList.remove('link-dragging');
      var link = _store_instance2.default.getLink(self.id);

      _this.dashArray = _this.getDashArray(link.lineType, link.lineWidth);

      var updateEndPoints = void 0;

      if (_this.endPointHits && _this.endPointHits.to) {
        var nodeId = _this.endPointHits.to.node.id;
        var endPoint = _this.endPointHits.to.endPoint;
        link.toNodeId = nodeId;
        endPoint.setNodeId(nodeId);
        updateEndPoints = true;
        _this.canvas.nodeTags[nodeId].toggleLineHover(false);
      }
      if (_this.endPointHits && _this.endPointHits.from) {
        var _nodeId = _this.endPointHits.from.node.id;
        var _endPoint = _this.endPointHits.from.endPoint;
        link.fromNodeId = _nodeId;
        _endPoint.setNodeId(_nodeId);
        updateEndPoints = true;
        _this.canvas.nodeTags[_nodeId].toggleLineHover(false);
      }
      if (updateEndPoints) {
        _relationshipUi.rui.updateEndpoints({ link: link });
        _this.updatePosition();
      }

      self.canvas.operation.setLinkAngles({
        linkUUID: self.id,
        angleStartToR: link.angleStartToR,
        angleEndToR: link.angleEndToR,
        prevAngleStartToR: prevAngleStartToR,
        prevAngleEndToR: prevAngleEndToR,
        onFailure: function onFailure(err) {
          console.log('setLinkAngles failure: ' + err);
        }
      });

      _this.updateMarkerEnds();
      _this.canvas.enablePanZoom();
    }
  });
});

this.setSelected = function () {
  if (_this.refs.container) {
    var _refs3 = _this.refs,
        svg = _refs3.svg,
        container = _refs3.container;
    var svgClass = svg.classList;
    var containerClass = container.classList;

    if (!svgClass.contains('selected')) svgClass.add('selected');
    if (!containerClass.contains('selected')) containerClass.add('selected');
    if (!containerClass.contains('expanded')) containerClass.add('expanded');
    _this.update();
  }
};

this.unsetSelected = function () {
  _this.expanded = false;
  if (_this.refs.container) {
    var _refs4 = _this.refs,
        svg = _refs4.svg,
        container = _refs4.container;
    var svgClass = svg.classList;
    var containerClass = container.classList;

    if (svgClass.contains('selected')) svgClass.remove('selected');
    if (svgClass.contains('expanded')) svgClass.remove('expanded');
    if (svgClass.contains('emphasized')) svgClass.remove('emphasized');
    if (svgClass.contains('hover')) svgClass.remove('hover');
    if (containerClass.contains('selected')) containerClass.remove('selected');
    if (containerClass.contains('expanded')) containerClass.remove('expanded');
    if (containerClass.contains('hover')) containerClass.remove('hover');
  }
  _this.update();
};

var _edgePoint = function _edgePoint(fromPt, middlePt, toPt, topLeft, _ref2, sweepFlag) {
  var _width = _ref2._width,
      _height = _ref2._height;

  var bottomRight = {
    x: topLeft.x + _width,
    y: topLeft.y + _height
  };

  var boxCenter = {
    x: topLeft.x + _width / 2,
    y: topLeft.y + _height / 2
  };

  var _findCircleFromPoints = (0, _geom.findCircleFromPoints)(fromPt, middlePt, toPt),
      center = _findCircleFromPoints[0],
      _ = _findCircleFromPoints[1];

  var points = (0, _geom.arcRectangleIntersectionPoints)(fromPt, middlePt, toPt, topLeft, bottomRight, true);

  if (points.length) {
    // for all intersection points, find the one we hit first if we start at from point and
    // travel along the arc in the sweepFlag direction
    for (var _iterator = points, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref3 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref3 = _i.value;
      }

      var p = _ref3;

      var fang = (0, _geom.computeSlope)(center, fromPt);
      var pang = (0, _geom.computeSlope)(center, p);
      p._adiff = (0, _geom.angleDiff)(fang, pang, sweepFlag);
    }
    return points.sort(function (a, b) {
      return a._adiff - b._adiff;
    })[0];
  } else {
    // we found no intersections, so go with the fromPoint itself
    return fromPt;
  }
};

this.describeArc = function () {
  var link = _store_instance2.default.getLink(_this.id);

  var _normalize = function _normalize(angle) {
    if (angle < 0) angle += 2 * Math.PI;
    if (angle > 2 * Math.PI) angle -= 2 * Math.PI;
    return angle;
  };

  if (!_this.showArc() || !link) {
    return { path: "M 0 0 L 0 0 ", rDistancePercentage: 0, arcLengthToN2: 0 };
  }

  var fromNodePoint = Object.assign({}, link.getFromEndPoint());
  var toNodePoint = Object.assign({}, link.getToEndPoint());

  // align link with center of endpoints

  var _canvas$getMatrix2 = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix2.scale,
      tx = _canvas$getMatrix2.tx,
      ty = _canvas$getMatrix2.ty;

  var fromPoint = Object.assign({}, fromNodePoint);
  var toPoint = Object.assign({}, toNodePoint);

  var fromNode = link.fromNode();
  fromNode = fromNode ? fromNode.getFirstVisibleAncestorNode() : fromNode;
  var toNode = link.toNode();
  toNode = toNode ? toNode.getFirstVisibleAncestorNode() : toNode;

  var fcp = void 0,
      tcp = void 0;

  if (fromNode) {
    fcp = Object.assign({}, fromNode.absolutePosition);
    fcp.x += fromNode.width / 2;
    fcp.y += fromNode.height / 2;
  } else {
    fcp = fromPoint;
  }

  if (toNode) {
    tcp = Object.assign({}, toNode.absolutePosition);
    tcp.x += toNode.width / 2;
    tcp.y += toNode.height / 2;
  } else {
    tcp = toPoint;
  }

  if (!fromNodePoint || !toNodePoint) {
    return { path: "M 0 0 L 0 0 ", rDistancePercentage: 0, arcLengthToN2: 0 };
  }

  var points = link.getOffsetLinkPoints();

  var rNodeTitleOffset = 17;

  var fromRef = void 0,
      toRef = void 0;

  if (fromNode) {
    fromRef = Object.assign({}, fromNode.absolutePosition);
    if (fromNode.getTopLevelParent().link()) {
      fromRef.x -= fromNode.getTopLevelParent().width / 2;
      fromRef.y -= rNodeTitleOffset;
    }
  }

  if (toNode) {
    toRef = Object.assign({}, toNode.absolutePosition);
    if (toNode.getTopLevelParent().link()) {
      toRef.x -= toNode.getTopLevelParent().width / 2;
      toRef.y -= rNodeTitleOffset;
    }
  }

  var toCenterPoint = points.toPoint;
  var fromCenterPoint = points.fromPoint;

  var relationshipCenterPoint = (0, _geom.getPointFromAngles)(fromCenterPoint, link.angleStartToR, toCenterPoint, link.angleEndToR);

  var _findCircleFromPoints2 = (0, _geom.findCircleFromPoints)(relationshipCenterPoint, fromCenterPoint, toCenterPoint),
      circleCenter = _findCircleFromPoints2[0],
      radius = _findCircleFromPoints2[1];

  // set angles relative to start angle

  var angleToStart = (0, _geom.computeSlope)(circleCenter, fromCenterPoint);
  var angleToEnd = _normalize((0, _geom.computeSlope)(circleCenter, toCenterPoint) - angleToStart);
  var angleToRelationship = _normalize((0, _geom.computeSlope)(circleCenter, relationshipCenterPoint) - angleToStart);

  var sweepFlag = 0 <= angleToRelationship && angleToRelationship <= angleToEnd ? 1 : 0;

  var fromEdgePoint = fromPoint;
  var toEdgePoint = toPoint;

  if (link._overrideFromPoint) {
    fromEdgePoint = link._overrideFromPoint;
  } else if (fromPoint._isAncestor) {
    fromEdgePoint = fromCenterPoint;
  } else if (fromNode) {
    var rect = { _width: fromNode.width, _height: fromNode.height };
    fromEdgePoint = _edgePoint(fromCenterPoint, relationshipCenterPoint, toCenterPoint, fromRef, rect, sweepFlag);
  }

  if (link._overrideToPoint) {
    toEdgePoint = link._overrideToPoint;
  } else if (toPoint._isAncestor) {
    toEdgePoint = toCenterPoint;
  } else if (toNode) {
    // reverse the order of params and reverse the sweep flag to get the to edge point
    var _rect = { _width: toNode.width, _height: toNode.height };
    toEdgePoint = _edgePoint(toCenterPoint, relationshipCenterPoint, fromCenterPoint, toRef, _rect, !sweepFlag, true);
  }

  if (fromEdgePoint == null || toEdgePoint == null) {
    return { path: "M 0 0", rDistancePercentage: 0, arcLengthToN2: 0, largeArcFlag: 0, sweepFlag: 0 };
  }

  var thirdPoint = (0, _geom.getPointFromAngles)(fromCenterPoint, link.angleStartToR, toCenterPoint, link.angleEndToR);

  var path = void 0,
      outerBox = void 0,
      rDistancePercentage = void 0,
      arcLengthToN2 = void 0,
      largeArcFlag = void 0;

  if (Number.isFinite(radius)) {

    angleToStart = (0, _geom.computeSlope)(circleCenter, fromEdgePoint);
    angleToEnd = _normalize((0, _geom.computeSlope)(circleCenter, toEdgePoint) - angleToStart);
    angleToRelationship = _normalize((0, _geom.computeSlope)(circleCenter, relationshipCenterPoint) - angleToStart);

    largeArcFlag = sweepFlag ^ angleToEnd >= Math.PI ? 0 : 1;

    var arcLengthToRNode = sweepFlag ? angleToRelationship * radius : (Math.PI * 2 - angleToRelationship) * radius;
    arcLengthToN2 = sweepFlag ? angleToEnd * radius : (Math.PI * 2 - angleToEnd) * radius;
    arcLengthToN2 -= 1;
    rDistancePercentage = arcLengthToRNode / arcLengthToN2 * 100;

    if (link.lineCurvature === 'elbow') {
      var isChildToParent = fromNode && toNode && fromNode.ancestors().includes(toNode);
      var isParentToChild = fromNode && toNode && fromNode.descendants().includes(toNode);

      var toRect = {
        width: toNode ? toNode.width : 0,
        height: toNode ? toNode.height : 0,
        left: (toNode && toNode.absolutePosition || toPoint).x,
        top: (toNode && toNode.absolutePosition || toPoint).y,
        x: (toNode && toNode.absolutePosition || toPoint).x,
        y: (toNode && toNode.absolutePosition || toPoint).y
      };

      var fromRect = {
        width: fromNode ? fromNode.width : 0,
        height: fromNode ? fromNode.height : 0,
        left: (fromNode && fromNode.absolutePosition || fromPoint).x,
        top: (fromNode && fromNode.absolutePosition || fromPoint).y,
        x: (fromNode && fromNode.absolutePosition || fromPoint).x,
        y: (fromNode && fromNode.absolutePosition || fromPoint).y
      };

      var dogLegResult = _linksUi.linksUI.getDogLegPath({
        thirdPoint: thirdPoint,
        fromCenterPoint: fromCenterPoint,
        toCenterPoint: toCenterPoint,
        fromRect: fromRect,
        toRect: toRect,
        fromPoint: fromPoint,
        toPoint: toPoint,
        isParentToChild: isParentToChild,
        isChildToParent: isChildToParent,
        fromNodeId: _this.fromNodeId,
        toNodeId: _this.toNodeId,
        linkId: _this.id
      });
      path = dogLegResult.pathString;
      _this.pathArray = dogLegResult.path;
    } else {
      path = _linksUi.linksUI.getArcPath({
        fromEdgePoint: fromEdgePoint,
        radius: radius,
        sweepFlag: sweepFlag,
        largeArcFlag: largeArcFlag,
        toEdgePoint: toEdgePoint
      });
    }
  } else {

    arcLengthToN2 = Math.sqrt(Math.pow(fromEdgePoint.x - toEdgePoint.x, 2) - Math.pow(fromEdgePoint.y - toEdgePoint.y, 2));
    var _arcLengthToRNode = Math.sqrt(Math.pow(fromEdgePoint.x - thirdPoint[0], 2) - Math.pow(fromEdgePoint.y - thirdPoint[1], 2));
    rDistancePercentage = _arcLengthToRNode / arcLengthToN2 * 100;

    path = 'M ' + fromEdgePoint.x + ' ' + fromEdgePoint.y + ' L ' + thirdPoint[0] + ' ' + thirdPoint[1] + ' L ' + toEdgePoint.x + ' ' + toEdgePoint.y;

    var _sort2 = function _sort2(a, b) {
      return [Math.min(a, b), Math.max(a, b)];
    };

    var _sort = _sort2(fromEdgePoint.x, toEdgePoint.x),
        left = _sort[0],
        right = _sort[1];

    var _sort3 = _sort2(fromEdgePoint.y, toEdgePoint.y),
        top = _sort3[0],
        bottom = _sort3[1];

    outerBox = {
      topLeft: { x: left, y: top },
      width: right - left,
      height: bottom - top
    };
  }
  _this.fromCenterPoint = fromCenterPoint;
  _this.toCenterPoint = toCenterPoint;
  _this.fromEdgePoint = fromEdgePoint;
  _this.toEdgePoint = toEdgePoint;
  _this.sweepFlag = sweepFlag;

  return { path: path, rDistancePercentage: rDistancePercentage, arcLengthToN2: arcLengthToN2, largeArcFlag: largeArcFlag, sweepFlag: sweepFlag, outerBox: outerBox, thirdPoint: thirdPoint, fromPoint: fromEdgePoint, toPoint: toEdgePoint, circleCenter: circleCenter, radius: radius };
};

// change position of link without calling update on the riot tag
this.updateDescribedArcFields = function (describedArc) {
  _this.largeArcFlag = describedArc.largeArcFlag;
  _this.sweepFlag = describedArc.sweepFlag;
  _this.arcLengthToN2 = describedArc.arcLengthToN2 || 0;
  _this.fromPoint = describedArc.fromPoint;
  _this.toPoint = describedArc.toPoint;
  _this.thirdPoint = describedArc.thirdPoint;
  _this.path = describedArc.path || 'M 0 0 L 0 0';
};

this.updateFromNodeDrag = function () {
  var link = _store_instance2.default.getLink(_this.id);

  var _self$canvas$getMatri2 = self.canvas.getMatrix(),
      scale = _self$canvas$getMatri2.scale,
      tx = _self$canvas$getMatri2.tx,
      ty = _self$canvas$getMatri2.ty;

  link.setAngles({
    lNodePoint: {
      x: (e.clientX - tx) / scale,
      y: (e.clientY - ty) / scale
    }
  });
};

this.updatePosition = function () {
  _this.updateEndPointPositions();
  _this._updatePosition();
};

this.updateEndPointPositions = function () {
  var _arr = [_this.instance.getFromEndPoint(), _this.instance.getToEndPoint()];

  for (var _i2 = 0; _i2 < _arr.length; _i2++) {
    var endPoint = _arr[_i2];
    var endPointTag = _this.canvas.linkEndPointTags[endPoint.id];
    endPointTag && endPointTag.updatePositionDisplay();
  }
};

this._updatePosition = function () {
  var describedArc = _this.describeArc();

  _this.updateDescribedArcFields(describedArc);

  $(_this.refs.path).attr('d', _this.path);
  $(_this.refs.container).attr('d', _this.path);
  _this.setClipPolygon();

  if (_this.linkNodeId) {
    _this.instance.placeLinkNode();
    if (_this.canvas.nodeTags[_this.linkNodeId]) {
      _this.canvas.nodeTags[_this.linkNodeId].updatePosition();
      _this.setClipPolygon(describedArc.outerBox);
    }
  }
  _this.updateMarkers();
};

this.updateMarkers = function () {
  _this.freshenArrowProps();
  var _toggle = function _toggle(cond, className) {
    if (!(_this.refs && _this.refs.svg)) return;
    var method = cond ? 'add' : 'remove';
    _this.refs.svg.classList[method](className);
  };
  _toggle(_this.showFromArrow, 'show-from-arrow');
  _toggle(_this.showToArrow, 'show-to-arrow');
  _toggle(_this.showFromDot, 'show-from-dot');
  _toggle(_this.showToDot, 'show-to-dot');
};

this.updateStyle = function () {
  var link = _store_instance2.default.getLink(_this.id);
  $(_this.refs.path).attr('stroke-width', _constants.LINK_WIDTHS_MAPPING[link.lineWidth]);

  $(_this.refs.container).removeClass(function (index, className) {
    return (className.match(/\bwidth-\S+/g) || []).join(' ');
  });

  $(_this.refs.svg).removeClass(function (index, className) {
    return (className.match(/\bsize-\S+/g) || []).join(' ');
  });

  _this.refs.svg.classList.add('size-' + link.lineWidth);
  _this.refs.container.classList.add('width-' + link.lineWidth);

  $(_this.refs.path).attr('stroke-dasharray', _this.getDashArray(link.lineType, link.lineWidth));

  _this.freshenArrowProps();
  _this.update();
};

this.updateCurvature = function () {
  _this.update();
};

this.updateCollapsedState = function () {
  if (!(self.refs && self.refs.svg)) return;
  if (_this.showCollapsedArc()) {
    self.refs.svg.classList.add('collapsed-link');
  } else {
    self.refs.svg.classList.remove('collapsed-link');
  }
};

this.updateHiddenState = function () {
  if (!(self.refs && self.refs.svg)) return;
  if (_this.showArc()) {
    self.refs.svg.classList.remove('hidden');
  } else {
    self.refs.svg.classList.add('hidden');
  }
};

this.updateDirectionState = function () {
  var link = _store_instance2.default.getLink(_this.id);
  _this.direction = link.direction;
  //this.canvas.linkHandlesTag.hide();
  _this.updateArrowCss();
};

this.updateArrowCss = function () {
  _this.freshenArrowProps();
  _this.update();

  switch (_this.direction) {
    case "right":
      {
        _this.pulseEndpoint('toArrow');
        break;
      }
    case "left":
      {
        _this.pulseEndpoint('fromArrow');
        break;
      }
    case "both":
      {
        _this.pulseEndpoint('toArrow');
        _this.pulseEndpoint('fromArrow');
        break;
      }

  }
};

this.pulseEndpoint = function (endpoint) {
  var getFontSize = function getFontSize(lineWidth) {
    switch (lineWidth) {
      case 'xs':
        return '8px';
      case 's':
        return '11px';
      case 'l':
        return '18px';
      case 'xl':
        return '24px';
    }
  };
  var originalFontSize = getFontSize(opts.instance.lineWidth);
  _this.refs[endpoint].style = 'font-size: ' + originalFontSize.slice(0, originalFontSize.length - 2) * 4 + 'px;';
  _this[endpoint + 'Timeout'] = setTimeout(function () {
    _this.refs[endpoint].style = '';
    clearTimeout(_this[endpoint + 'Timeout']);
  }, 500);
};

this.updateStrokeColor = function () {
  var link = _store_instance2.default.getLink(_this.id);
  _this.color = link.color;
  _this.update();
};

this.removeClipPolygon = function () {
  var _refs5 = _this.refs,
      svg = _refs5.svg,
      clipPathPath = _refs5.clipPathPath;

  if (!clipPathPath) return;
  var nodeClipPath = _this.instance.linkNodeId ? "M " + _this.getNodeClipPath(_store_instance2.default.getNode(_this.instance.linkNodeId)) : '';

  svg && svg.classList.add('emphasized');
  clipPathPath.setAttribute('d', 'M -10000,-10000 10000,-10000 10000,10000 -10000,10000 -10000,-10000 ' + nodeClipPath);
};

this.setClipPolygon = function () {
  _this.isPendingSetClipPolygon = true;
  if (_this.isPendingSetClipPolygon) {
    _this.isPendingSetClipPolygon = false;
    _this._setClipPolygon();
  }
};

this.getNodeClipPath = function (n) {
  var nudge = 4;
  // compensate for -17px translateY on r cards
  var relationshipCardYOffset = 17;
  var hasLink = n.link();

  var _ref4 = hasLink ? _linksUi.linksUI.skewDeltas[n.link().id] || { dx: 0, dy: 0 } : { dx: 0, dy: 0 },
      dx = _ref4.dx,
      dy = _ref4.dy;

  dx = Number.isFinite(dx) ? dx : 0;
  dy = Number.isFinite(dy) ? dy : 0;

  var xoff = hasLink ? n.width / 2 - dx : 0;
  var yoff = hasLink ? relationshipCardYOffset - dy : 0;
  var margin = hasLink ? -2 : n.getGoverningLayoutName() == 'layout-freehand' ? 0 : -5;

  return [[n.absolutePosition.x + margin - xoff, n.absolutePosition.y + margin - yoff], [n.absolutePosition.x + margin - xoff, n.absolutePosition.y + n.height - margin - yoff], [n.absolutePosition.x + n.width - margin - xoff, n.absolutePosition.y + n.height - margin - yoff], [n.absolutePosition.x + n.width - margin - xoff, n.absolutePosition.y + margin - yoff], [n.absolutePosition.x + margin - xoff, n.absolutePosition.y + margin - yoff]];
};

this.getChildNodesClipPath = function (n) {

  var margin = 5;

  // account for container padding...
  var bottomNudge = 11;
  var rightNudge = 5;

  var top = n.absolutePosition.y + n.childrenPosition.y;
  var left = n.absolutePosition.x + n.childrenPosition.x;
  var width = n.childrenPosition.width + rightNudge;
  var height = n.childrenPosition.height + bottomNudge;

  return [[left - margin, top - margin], [left - margin, top + height + margin], [left + margin + width, top + height + margin], [left + margin + width, top - margin], [left - margin, top - margin]];
};

this._setClipPolygon = function () {
  if (_this.canvas.dragging) {
    _this.removeClipPolygon();
    return;
  }
  var link = _this.canvas.store.getLink(_this.id);
  var _refs6 = _this.refs,
      clipPathPath = _refs6.clipPathPath,
      svg = _refs6.svg;

  var fromNode = link.fromNode();
  var toNode = link.toNode();
  var toNodeParent = toNode ? toNode.getParent() : null;
  var fromNodeParent = fromNode ? fromNode.getParent() : null;

  var commonFreehandParent = fromNodeParent && fromNodeParent == toNodeParent && fromNodeParent.layoutName == 'layout-freehand' ? fromNodeParent : null;

  var nodeCoords = _store_instance2.default.getNodesArray().filter(function (n) {
    return Number.isFinite(n.absolutePosition.x + n.absolutePosition.y + n.width + n.height);
  }).filter(function (n) {
    return !n.parentId || commonFreehandParent == n.getParent() && fromNode && fromNode.getTopNonFreehandParent() != n && toNode && toNode.getTopNonFreehandParent() != n;
  }).filter(function (n) {
    return n !== commonFreehandParent;
  }).filter(function (n) {
    return fromNode && n != fromNode.getTopLevelParent() && toNode && n != toNode.getTopLevelParent();
  }).map(_this.getNodeClipPath);

  var childNodesCoords = _store_instance2.default.getNodesArray().filter(function (n) {
    return n.childrenDetached && !n.isCollapsed;
  }).filter(function (n) {
    return Number.isFinite(n.absolutePosition.x + n.absolutePosition.y + n.childrenPosition.width + n.childrenPosition.height);
  }).filter(function (n) {
    return !n.parentId || commonFreehandParent == n.getParent() && fromNode && fromNode.getTopNonFreehandParent() != n && toNode && toNode.getTopNonFreehandParent() != n;
  }).filter(function (n) {
    return fromNode && n != fromNode.getTopLevelParent() && toNode && n != toNode.getTopLevelParent();
  }).map(_this.getChildNodesClipPath);

  var coords = [].concat(nodeCoords, childNodesCoords).map(function (c) {
    return c.join(",");
  }).join(" M ");
  if (coords.length && clipPathPath) {
    var polyString = "M -10000,-10000 10000,-10000 10000,10000 -10000,10000 -10000,-10000 M" + coords;
    clipPathPath.setAttribute('d', polyString);
  }

  svg && svg.classList.remove('emphasized');
};

this.refreshPerspectiveHighlight = function () {
  var perspectives = _perspectivesUi.pui.getActivePerspectives();
  // if link was explicitly added to this perspective, or its endpoints are both members, then highlight this line
  if (perspectives.some(function (p) {
    return p.hasMemberLink(_this.id) || _this.fromNodeId && p.hasMemberNode(_this.fromNodeId) && _this.toNodeId && p.hasMemberNode(_this.toNodeId);
  })) {
    _this.perspectiveHighlight();
  } else {
    _this.perspectiveUnHighlight();
  }
};

this.perspectiveHighlight = function () {
  _this.perspectiveHighlighted = true;
  if (_this.refs && _this.refs.svg && !_this.refs.svg.classList.contains('tag-selected')) {
    _this.refs.svg.classList.add('tag-selected');
  }
};

this.perspectiveUnHighlight = function () {
  _this.perspectiveHighlighted = false;
  if (_this.refs && _this.refs.svg && _this.refs.svg.classList.contains('tag-selected')) {
    _this.refs.svg.classList.remove('tag-selected');
  }
};

this.setPresenceHovered = function () {
  if (_this.refs && _this.refs.svg && !_this.refs.svg.classList.contains('user-presence-highlight')) {
    _this.refs.svg.classList.add('user-presence-highlight');
  }
};

this.unsetPresenceHovered = function () {
  _this.perspectiveHighlighted = false;
  if (_this.refs && _this.refs.svg && _this.refs.svg.classList.contains('user-presence-highlight')) {
    _this.refs.svg.classList.remove('user-presence-highlight');
  }
};

this.setLocalBorderHighlightColor = function (color) {
  if (_this.refs && _this.refs.svg) {
    _this.refs.svg.style.setProperty('--card-border-highlight-color', color);
  }
};

this.unsetLocalBorderHighlightColor = function (color) {
  if (_this.refs && _this.refs.svg) {
    _this.refs.svg.style.removeProperty('--card-border-highlight-color');
  }
};

this.fadeIn = function () {
  if (_this.refs && _this.refs.svg) {
    _this.refs.svg.classList.add('waypoint-focused');
  }
};

this.fadeOut = function () {
  if (_this.refs && _this.refs.svg) {
    _this.refs.svg.classList.remove('waypoint-focused');
  }
};

this.getLineType = function () {
  return opts.instance.lineType;
};

this.straightenLine = function () {
  var link = _store_instance2.default.getLink(_this.id);
  _relationshipUi.rui.straightenLine(link);
  //this.canvas.linkHandlesTag.position();
};

this.updateMarkerEnds = function () {
  var path = _this.refs.path;

  var marker = _this.getMarker();

  path.setAttribute('marker-end', marker);
  path.setAttribute('marker-start', marker);
};

this.getMarker = function () {
  if (_this.canvas.linkDragging == _this.id) {
    return 'url(#diamond-selected-hovered)';
  }

  if (_this.isSelected()) {
    if (_this.hovered) {
      return 'url(#diamond-selected-hovered)';
    }
    return 'url(#diamond-selected)';
  } else if (_this.endpointHovered) {
    return 'url(#diamond-selected-hovered)';
  }

  return '';
};

this.endRefs = function () {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  var refs = [_this.refs.fromDot, _this.refs.fromDotBacking, _this.refs.fromArrow, _this.refs.fromArrowBacking, _this.refs.toDot, _this.refs.toDotBacking, _this.refs.toArrow, _this.refs.toArrowBacking];
  return refs.filter(function (el) {
    return el && el.matches(selector);
  });
};

this.resetEnds = function () {
  for (var _iterator2 = _this.endRefs('[data-x]'), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref5;

    if (_isArray2) {
      if (_i3 >= _iterator2.length) break;
      _ref5 = _iterator2[_i3++];
    } else {
      _i3 = _iterator2.next();
      if (_i3.done) break;
      _ref5 = _i3.value;
    }

    var el = _ref5;

    el.setAttribute('x', el.getAttribute('data-x'));
  }
  for (var _iterator3 = _this.endRefs('[data-shifted-hidden]'), _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref6;

    if (_isArray3) {
      if (_i4 >= _iterator3.length) break;
      _ref6 = _iterator3[_i4++];
    } else {
      _i4 = _iterator3.next();
      if (_i4.done) break;
      _ref6 = _i4.value;
    }

    var _el = _ref6;

    _el.style = null;
  }
};

this.shiftEnds = function () {
  for (var _iterator4 = _this.endRefs('[data-shifted-x]'), _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
    var _ref7;

    if (_isArray4) {
      if (_i5 >= _iterator4.length) break;
      _ref7 = _iterator4[_i5++];
    } else {
      _i5 = _iterator4.next();
      if (_i5.done) break;
      _ref7 = _i5.value;
    }

    var el = _ref7;

    el.setAttribute('x', el.getAttribute('data-shifted-x'));
  }
  for (var _iterator5 = _this.endRefs('[data-shifted-hidden]'), _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
    var _ref8;

    if (_isArray5) {
      if (_i6 >= _iterator5.length) break;
      _ref8 = _iterator5[_i6++];
    } else {
      _i6 = _iterator5.next();
      if (_i6.done) break;
      _ref8 = _i6.value;
    }

    var _el2 = _ref8;

    _el2.style.display = 'none';
  }
};

this.getDashArray = _linksUi.linksUI.getDashArray;

this.freshen();
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('link')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/link.html
// module id = 603
// module chunks = 0